export default __webpack_public_path__ + "static/media/046-tank.8d86c59e.png";